import { render, staticRenderFns } from "./quCode.vue?vue&type=template&id=740c8b00&scoped=true&"
import script from "./quCode.vue?vue&type=script&lang=js&"
export * from "./quCode.vue?vue&type=script&lang=js&"
import style0 from "./quCode.vue?vue&type=style&index=0&id=740c8b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c8b00",
  null
  
)

export default component.exports